import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import SecureLS from 'secure-ls'
import { login, logout } from 'src/api/userAPI'

const secureLs = new SecureLS()

const defaultState = {
  sidebarShow: true,
  isLoggedIn: false,
  id: undefined,
  username: undefined,
  email: undefined,
  image: undefined,
  cpf: undefined,
  password: undefined,
  token: undefined,
  completed: undefined,
  role: undefined,
  company: undefined,
}

const getStateFromStorage = () => {
  const appcAuth = secureLs.get('appc-auth-mkplace')

  let stateInLocalStorage = {
    sidebarShow: false,
    isLoggedIn: false,
    username: undefined,
    email: undefined,
    image: undefined,
    cpf: undefined,
    password: undefined,
    completed: undefined,
    role: undefined,
    company: undefined,
  }

  if (appcAuth) {
    return appcAuth
  }
  return stateInLocalStorage
}

export const loginHandler = createAsyncThunk('/user/login', async (credentials) => {
  const response = await login(credentials)
  const authState = {
    sidebarShow: true,
    id: response.data.id,
    username: response.data.username,
    firstname: response.data.firstname,
    lastname: response.data.lastname,
    image: response.data.image,
    token: response.data.token,
    phone: response.data.phone,
    cpf: response.data.cpf,
    email: response.data.email,
    admin: response.data.admin,
    completed: response.data.completed,
    role: response.data.role,
    company: response.data.company,
    ...credentials,
  }
  return authState
})

export const logoutSuccess = createAsyncThunk('user/logout', async (state) => {
  try {
    await logout()
  } catch (err) {
    console.log('backend not ready with logout')
  }
  return defaultState
})

export const authSlice = createSlice({
  name: 'auth',
  initialState: { user: { ...getStateFromStorage() } },
  reducers: {
    updateSuccess: (
      state,
      { firstname, lastname, city, internalState, gender, birthdate, image },
    ) => {
      state.user = {
        ...state.user,
        firstname,
        lastname,
        city,
        state: internalState,
        gender,
        birthdate,
        image,
        completed: true,
      }
    },
    updateProfilePicture: (state, image) => {
      state.user = {
        ...state.user,
        image: image.payload,
      }
    },
    updateShowSideBar: (state, show) => {
      state.user = {
        ...state.user,
        sidebarShow: show.payload,
      }
    },
    updatePlanSuccess: (state, { plan }) => {
      state.user = {
        ...state.user,
        plan,
      }
    },
    updateCompanySuccess: (state, company) => {
      state.user = {
        ...state.user,
        company: company.payload,
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(loginHandler.fulfilled, (state, action) => {
      state.user = { ...action.payload, isLoggedIn: true }
    })
    builder.addCase(logoutSuccess.fulfilled, (state, action) => {
      state.user = { ...action.payload }
    })
  },
})

export const {
  updateSuccess,
  updateShowSideBar,
  updatePlanSuccess,
  updateCompanySuccess,
  updateProfilePicture,
} = authSlice.actions

export default authSlice.reducer
